import React from "react";
import { motion } from "framer-motion";

const Education = ({ education }) => {
  return (
    <section
      id="education"
      className="relative py-8 md:py-12 lg:py-16 px-4  overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-20 dark:opacity-5">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96  rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20 space-y-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            className="glass inline px-4 py-2 rounded-full border border-purple-500/30 hover:border-purple-400/60 transition-all duration-300"
          >
            🎓 Academic Background
          </motion.div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black gradient-text">
            Education
          </h2>
          <p className="text-base md:text-lg text-gray-600 dark:text-gray-400">
            Building a strong foundation in computer science and technology
          </p>
        </div>

        {/* Education Cards */}
        <div className="space-y-6 md:space-y-8">
          {education.map((edu, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 lg:p-10 rounded-2xl shadow-lg hover:shadow-2xl hover:shadow-orange-500/30 transition-all duration-500 transform hover:-translate-y-4 border-
              border-purple-500/20 hover:border-purple-400/50 glass relative"
            >
              {/* Animated background gradient */}
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 via-orange-500/5 to-orange-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

              <div className="relative z-10">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
                  <div className="flex items-start gap-4">
                    <span className="text-5xl md:text-6xl group-hover:scale-125 group-hover:rotate-12 transition-transform duration-300">
                      🎓
                    </span>
                    <div>
                      <h3 className="text-2xl text-purple-300 md:text-3xl font-black bg-gradient-to-r from-orange-600 to-orange-500 dark:from-orange-400 dark:to-orange-300 bg-clip-text  group-hover:scale-110 transition-transform duration-300 inline-block">
                        {edu.degree}
                      </h3>
                      <p className="text-base md:text-lg font-bold mt-2 text-gray-900 dark:text-white">
                        {edu.field}
                      </p>
                    </div>
                  </div>
                  <div className="inline-block px-4 py-2 bg-blue-500/20 text-blue-300 rounded-lg text-sm md:text-base font-bold border">
                    {edu.year}
                  </div>
                </div>

                <div className="flex sm:items-center sm:gap-4 mb-6">
                  <span className="text-2xl mr-2">🏫</span>
                  <p className="glass inline px-4 py-2 rounded-full border border-purple-500/30 hover:border-purple-400/60 transition-all duration-300">
                    {edu.institution}
                  </p>
                </div>

                {/* Progress bar */}
                <div className="h-1 bg-gradient-to-r from-purple-500 via-purple-300 to-transparent rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-center"></div>
              </div>

              {/* Subtle corner accent */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-purple-500/10 to-transparent rounded-bl-3xl group-hover:from-purple-500/20 transition-all duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Motivational section */}
        <div className="glass mt-12 md:mt-20 p-6 md:p-10 rounded-2xl border-2 border-purple-500/20 hover:border-purple-400/50 transition-all duration-300 shadow-lg">
          <p className="text-center text-gray-500 text-sm md:text-base leading-relaxed">
            <span className="font-black text-purple-300 ">
              🚀 Continuous Learning:
            </span>{" "}
            Beyond formal education, I actively engage in online courses, coding
            challenges, community projects, and stay updated with the latest
            technologies and industry best practices.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Education;
